import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

export const contestPanelStyles: Record<string, SystemStyleObject<Theme>> = {
  root: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    backgroundColor: 'background.paper',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2.5,
    padding: 2.5,
  },
  heroCard: {
    position: 'relative',
    overflow: 'hidden',
    minHeight: 250,
    borderRadius: '10px',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'stretch',
    p: 0,
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background:
        'linear-gradient(180deg, rgba(0, 0, 0, 0.18) 0%, rgba(0, 0, 0, 0.28) 45%, rgba(0, 0, 0, 0.62) 100%)',
      zIndex: 1,
    },
  },
  badge: {
    position: 'absolute',
    top: 16,
    left: 16,
    zIndex: 3,
    px: 1.1,
    py: 0.55,
    borderRadius: 1.5,
    fontSize: '0.82rem',
    fontWeight: 700,
    color: 'text.primary',
    backgroundColor: 'rgba(255, 255, 255, 0.94)',
    boxShadow: '0 8px 18px rgba(0, 0, 0, 0.12)',
  },
  heroContent: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  heroContentPreStart: {
    padding: '44px 24px 18px',
  },
  heroContentCompact: {
    padding: '44px 22px 16px',
  },
  heroTitle: {
    fontSize: '1.35rem',
    fontWeight: 800,
    lineHeight: 1.2,
    mb: 0.95,
    color: '#ffffff',
    maxWidth: '100%',
  },
  heroDescription: {
    fontSize: '0.88rem',
    fontWeight: 500,
    lineHeight: 1.35,
    color: 'rgba(255,255,255,0.92)',
    maxWidth: '100%',
  },
  countdownWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    mt: 1.35,
    width: 'fit-content',
  },
  countdownNote: {
    mt: 0.7,
    fontSize: '0.68rem',
    lineHeight: 1.2,
    fontStyle: 'italic',
    color: 'rgba(255,255,255,0.88)',
  },
  heroDescriptionCompact: {
    maxWidth: '100%',
  },
  countdownCard: {
    width: 36,
    height: 44,
    px: 0,
    py: 0,
    borderRadius: 1,
    border: '1px solid rgba(255,255,255,0.45)',
    backgroundColor: 'rgba(255,255,255,0.18)',
    backdropFilter: 'blur(3px)',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  countdownValue: {
    fontSize: '0.88rem',
    lineHeight: 1,
    fontWeight: 800,
    color: '#ffffff',
  },
  countdownLabel: {
    mt: 0.22,
    fontSize: '0.62rem',
    lineHeight: 1,
    color: 'rgba(255,255,255,0.95)',
  },
  statusCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    p: 2,
    borderRadius: 2.5,
    border: '1px solid transparent',
  },
  statusCardInfo: {
    bgcolor: '#DCEBFF',
    borderColor: '#BBD5FF',
    color: '#1D3557',
  },
  statusCardSuccess: {
    bgcolor: '#EAF9EF',
    borderColor: '#BFE9CA',
    color: '#006635',
  },
  statusCardSuccessAligned: {
    alignItems: 'center',
  },
  statusCardNeutral: {
    bgcolor: '#F4F7FB',
    borderColor: '#DDE5EE',
    color: '#304255',
  },
  statusIconWrapInfo: {
    width: 32,
    height: 32,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  statusIconWrapSuccess: {
    width: 32,
    height: 32,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  statusTextSuccess: {
    color: 'inherit',
    fontSize: '0.92rem',
    lineHeight: 1.45,
  },
  statusIconWrapNeutral: {
    width: 32,
    height: 32,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  entriesCardWrap: {
    position: 'relative',
    pt: 0.25,
  },
  entriesCard: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    gap: 2.5,
    alignItems: 'center',
    p: 2.25,
    borderRadius: 2,
    border: '1px solid #F1C76D',
    backgroundColor: '#FFF4D6',
  },
  entriesTitle: {
    color: '#B07A00',
    fontSize: '0.9rem',
    fontWeight: 700,
    mb: 0.8,
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
  },
  entriesValue: {
    color: '#9B5E00',
    fontSize: '2rem',
    lineHeight: 1,
    fontWeight: 800,
    mb: 0.4,
  },
  entriesCaption: {
    color: '#7F5200',
    lineHeight: 1.35,
  },
  entriesMeta: {
    textAlign: 'right',
    pl: 2,
    borderLeft: '2px dashed #E3B24B',
  },
  entriesMetaText: {
    color: '#B07A00',
    mb: 0.45,
  },
  entriesMetaDate: {
    color: '#7F5200',
    fontWeight: 700,
  },
  sectionDivider: {
    border: 0,
    borderTop: '1px solid',
    borderColor: 'divider',
    margin: 0,
  },
  howToList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  howToItem: {
    display: 'grid',
    gridTemplateColumns: '28px 1fr',
    alignItems: 'flex-start',
    gap: 1.5,
  },
  howToBadge: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EEF8FF',
    color: '#17324D',
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1,
  },
  howToText: {
    color: '#3B4753',
    fontSize: '0.98rem',
    lineHeight: 1.4,
  },
  helperText: {
    mt: 2,
    color: '#6B7C8F',
    lineHeight: 1.45,
  },
  statusIconImage: {
    width: 24,
    height: 24,
    display: 'block',
  },
  statusWinnerIconImage: {
    width: 28,
    height: 28,
    display: 'block',
  },
  secondaryActionButton: {
    minHeight: 44,
    borderRadius: 999,
    textTransform: 'none',
    fontWeight: 600,
    borderColor: '#B8C3CF',
    color: '#304255',
  },
  footerText: {
    color: '#7A8897',
    fontSize: '0.85rem',
    lineHeight: 1.55,
  },
  footerLink: {
    color: '#0396C8',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};
